/**
 * Shared security patterns for detecting suspicious domains
 * Used by both CSP violation reporting and iframe telemetry
 */

// Known typo-squatting patterns to detect
const SUSPICIOUS_PATTERNS = [
  /blockdaem[o0]n/i, // Missing 'o' or using zero
  /bl[o0]ckdaemon/i, // Missing 'o' or using zero
  /blockdaemon\.(tk|ml|ga|cf)/i, // Suspicious TLDs
  /wollet/i, // Common wallet typos
  /metamosk/i, // MetaMask typo
  /wallect/i, // Wallet typo
];

/**
 * Check if domain matches suspicious patterns
 */
export function isSuspiciousDomain(domain: string): boolean {
  return SUSPICIOUS_PATTERNS.some((pattern) => pattern.test(domain));
}
